import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Modal,
  Button,
  ListItemText,
} from "@mui/material";
import { ArrowDropDown, CheckBox, LocationCityOutlined, LocationOn, Search } from "@mui/icons-material";
// import { serverUrl } from '../server';
import CloseIcon from "@mui/icons-material/Close";
import { getRequest, patchRequest, server } from "../config";
import moment from "moment";
import dayjs from "dayjs";
import Contract from "../components/bookings/Contract";
import LocationModal from "../components/bookings/LocationModal";

const Bookings = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [customers, setCustomers] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedCity, setSelectedCity] = useState("");
  const [allCities, setallCities] = useState([]);
  const [backData, setbackData] = useState([]);
  const [status, setstatus] = useState("upcoming");
  const [actualValue, setactualValue] = useState({ name: "All Cities" });
  const [isModalVisible, setisModalVisible] = useState(false);
  const [bookings, setBookings] = useState([]);
  const [filterType, setFilterType] = useState("all"); // Default to "Today"
  const [specificDate, setSpecificDate] = useState();
  const [selectedService, setselectedService] = useState(null);
  const [activePartner, setactivePartner] = useState({});
  const [availablePartners, setavailablePartners] = useState([]);
  const [showContract, setshowContract] = useState(null)
const [locationData, setlocationData] = useState(null)
  const durationOptions = [
    { label: "All Bookings", value: "all" },
    { label: "Today", value: "today" },
    { label: "This Week", value: "week" },
    { label: "This Month", value: "month" },
    { label: "Specific Date", value: "specific" },
  ];
  const allColumns = [
    { key: "customerName", label: "Customer Name" },
    { key: "mobileNumber", label: "Mobile Number" },
    { key: "service.subCategoryName", label: "SubCategory" },
    { key: "service.serviceType", label: "Service Type" },
    { key: "service.categoryName", label: "Category" },
    { key: "bookingId", label: "BookingId" },
    { key: "address", label: "Address" },
    { key: "pincode", label: "PinCode" },
    { key: "serviceDate", label: "Booking At" },
    {key:'',label:''}
  ];
  const calculateDistance = (
    lat1,
    lng1,
    lat2,
    lng2
  ) => {
    const R = 6371; // Radius of the Earth in km
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLng = (lng2 - lng1) * (Math.PI / 180);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLng / 2) *
        Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // Distance in km
  };
  useEffect(() => {
    fetchCustomers();
  }, [
    searchQuery,
    page,
    rowsPerPage,
    selectedCity,
    status,
    filterType,
    specificDate,
  ]);
  useEffect(() => {
    fetchCities();
  }, []);
  // Fetch customers from the LoopBack backend with filter and pagination

  const fetchCities = async () => {
    try {
      const uri = server.uri + "cities";
      const citiesData = await getRequest(uri);
      if (citiesData) {
        setallCities(citiesData);
        setbackData(citiesData);
      }
    } catch (error) {}
  };

  const fetchCustomers = async () => {
    try {
      let dateFilter = "";
      const today = dayjs().startOf("day");
      const weekStart = dayjs().startOf("week");
      const monthStart = dayjs().startOf("month");
      const specific = specificDate ? dayjs(specificDate).startOf("day") : null;
      if (filterType === "today") {
        dateFilter = { serviceDate: { gte: today.toISOString() } };
      } else if (filterType === "week") {
        dateFilter = { serviceDate: { gte: weekStart.toISOString() } };
      } else if (filterType === "month") {
        dateFilter = { serviceDate: { gte: monthStart.toISOString() } };
      } else if (filterType === "specific" && specific) {
        dateFilter = {
          serviceDate: {
            gte: specific.toISOString(),
            lt: specific.add(1, "day").toISOString(),
          },
        };
      }
      if (Object.keys(dateFilter).length > 0) {
        dateFilter = JSON.stringify(dateFilter);
        dateFilter = dateFilter.slice(1, dateFilter.length - 1);
      }

      const filter = {
        skip: page * rowsPerPage,
        limit: rowsPerPage,
      };

      if (selectedCity) {
        const response = await getRequest(
          `${server.uri}service-requests?filter={
        "where":{
        "or":[
        {"customerName":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}}
        
      ],"city":"${selectedCity}","status":"${status}"${
            dateFilter ? "," + dateFilter : ""
          }},
      "skip":"${filter.skip}",
        "limit":"${filter.limit}"
        ,"order":"createdAt desc","include":[{"relation":"user"},{"relation":"service"}]}`
        );
        //   console.log(response);

        setCustomers(response);
        const responseCount = await getRequest(
          `${server.uri}service-requests/count?where={
        
        "or":[
        {"name":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}}
      ],"city":"${selectedCity}","status":"${status}"${
            dateFilter ? "," + dateFilter : ""
          }}`
        );

        console.log(responseCount);

        setTotalCount(responseCount.count);
      } else {
        const response = await getRequest(
          `${server.uri}service-requests?filter={
        "where":{
        "or":[
        {"customerName":{"like":"${searchQuery}"}},
        {"mobileNumber":{"like":"${searchQuery}"}}
        
      ],"status":"${status}"${dateFilter ? "," + dateFilter : ""}},"skip":"${
            filter.skip
          }",
        "limit":"${filter.limit}"
        ,"order":"createdAt desc","include":[{"relation":"user"},{"relation":"service"}]}`
        );
        //   console.log(response);

        setCustomers(response);
        const responseCount = await getRequest(
          `${server.uri}service-requests/count?where={
            
            "or":[
            {"name":{"like":"${searchQuery}"}},
            {"mobileNumber":{"like":"${searchQuery}"}}
          ],"status":"${status}"${dateFilter ? "," + dateFilter : ""}}`
        );

        console.log(responseCount);

        setTotalCount(responseCount.count);
      }
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };
  const handleAssignWork=async(id, serviceId, managerId)=>{
    var raw = {
      status: 'upcoming',
      partnerId: id,
      serviceId: serviceId,
      managerId: managerId,
    };
    let uri = server.uri + 'service-requests/' + selectedService?.serviceRequestId;
    const changePartner = await patchRequest(uri, raw);
    if(changePartner==204){
      setisModalVisible(false)
    }

  }

  const fetchActivePartner = async (userId) => {
    try {
      const uri = server.uri + `users/${userId}`;
      const getPartner = await getRequest(uri);
      if (getPartner) setactivePartner(getPartner);
    } catch (error) {}
  };
  const fetchAvailablePartners = async (subCategoryId, city, pincode) => {
    try {
      const uri =
        server.uri +
        `services?filter={"where":{"subCategoryId":"${subCategoryId}"},"include":[{"relation":"partner"}]}`;
      const getPartner = await getRequest(uri);
      
      if (getPartner){
        const filter=getPartner?.filter((item)=>item?.partner)
        const nearbyServices = [];
        for (let service of filter) {
        console.log(service);
        
            const distance = calculateDistance(
              service.location?.lat,
              service?.location?.lng,
              selectedService?.user?.location?.lat,
              selectedService?.user?.location?.lng
            );
            console.log(distance);
            
    
           
              service.totalDistance = distance?.toFixed(2);
              nearbyServices.push(service);
            
          
        }
        console.log(nearbyServices);
        
        setavailablePartners(filter);
      } 
    } catch (error) {
     console.log(error);
     
    }
  };
  const handleDrawerOpen = async (service) => {
    setselectedService(service);
    await fetchActivePartner(service?.partnerId);
    await fetchAvailablePartners(
      service?.subCategoryId,
      service?.city,
      service?.pincode
    );
    setisModalVisible(true);
  };
  // Handle search query change
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setPage(0); // Reset to the first page when search changes
  };

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Reset to the first page when rows per page changes
  };
  const handleCityChange = (event, value) => {
    setSelectedCity(value?.name);
    setactualValue(value);
    setPage(0); // Reset to the first page when city changes
  };
  const handleChangeStatus = (e) => {
    setstatus(e.target.value);
    setPage(0);
  };
  const [selectedColumns, setSelectedColumns] = useState(
    allColumns.map((c) => c.key) // default: show all
  );

  const handleChange = (event) => {
    setSelectedColumns(event.target.value);
  };

  const visibleColumns = allColumns.filter((c) =>
    selectedColumns.includes(c.key)
  );
  const cities = ["upcoming", "ongoing", "completed"]; // Example city list
  return (
    <Container>
      {locationData&&<LocationModal locationData={locationData} onClose={()=>setlocationData(null)}/>}
      <Typography variant="h4" sx={{ marginTop: 8, marginBottom: 2 }}>
        Bookings List
      </Typography>
      {
        showContract&&<Contract bookingId={showContract} visible={showContract?true:false} onClose={()=>setshowContract(null)}/>
      }
      {/* Search Bar */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        {/* Search Bar */}
        <TextField
          variant="outlined"
          placeholder="Search by Customer name/Mobile Number"
          fullWidth
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
          }}
          sx={{ marginRight: 2 }}
        />
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2, marginRight: 2 }}
        >
          <TextField
            select
            label="Filter by Duration"
            value={filterType}
            onChange={(e) => setFilterType(e.target.value)}
            fullWidth
          >
            {durationOptions?.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          {/* Specific Date Input (Visible only for "Specific Date" filter) */}
          {filterType === "specific" && (
            <TextField
              type="date"
              label="Select Date"
              InputLabelProps={{ shrink: true }}
              value={specificDate}
              onChange={(e) => setSpecificDate(e.target.value)}
              fullWidth
            />
          )}
        </Box>

        <FormControl
          variant="outlined"
          sx={{ minWidth: 200, marginRight: "10px" }}
        >
          <InputLabel>Status</InputLabel>
          <Select
            value={status}
            onChange={handleChangeStatus}
            label="City"
            fullWidth
          >
            {/* <MenuItem value="">
              <em>All Cities</em>
            </MenuItem> */}
            {cities?.map((city) => (
              <MenuItem key={city} value={city}>
                {city}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        {/* City Dropdown */}
        <FormControl variant="outlined" sx={{ minWidth: 200 }}>
          {/* <InputLabel>City</InputLabel> */}
          <Autocomplete
            value={actualValue}
            onChange={handleCityChange}
            // label="City"
            getOptionLabel={(option) => option?.name}
            options={allCities}
            fullWidth
            freeSolo
            renderInput={(params) => (
              <TextField
                onch
                {...params}
                label="Search City"
                variant="outlined"
                fullWidth
              />
            )}
            renderOption={(props, option) => (
              <MenuItem {...props} key={option?.cityId}>
                {option?.name}
              </MenuItem>
            )}
          />
        </FormControl>
      </Box>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
      <FormControl sx={{ m: 2, minWidth: 100 }}>
        <InputLabel>Choose Fields</InputLabel>
        <Select
          multiple
          value={selectedColumns}
          onChange={handleChange}
          renderValue={(selected) =>
            allColumns
              .filter((c) => selected.includes(c.key))
              .map((c) => c.label)
              .join(", ")
          }
        >
          {allColumns?.map((col) => (
            <MenuItem key={col.key} value={col.key}>
              {/* <CheckBox checked={false} /> */}
              {/* <ListItemText primary={col.label} /> */}
              <p>{col.label}</p>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Typography sx={{ textAlign: "right" }} variant="subtitle1" gutterBottom>
        Total Bookings: <strong>{totalCount}</strong>
      </Typography>
    
      </div>
      {/* Customer Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f4f6f8", // Light background for table header
                }}
              >
                {/* <TableCell sx={{ fontWeight: "bold" }}>Customer Name</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Mobile Number</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>SubCategory</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Service Type</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Category</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>BookingId</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Address</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>PinCode</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Booking At</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}></TableCell> */}
                  {visibleColumns?.map((col) => (
                <TableCell key={col.key} sx={{ fontWeight: "bold" }}>
                  {col.label}
                </TableCell>
                
              ))}
              <TableCell></TableCell>
              <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers?.map((customer) => (
                <TableRow
                  sx={{
                    "&:nth-of-type(even)": {
                      backgroundColor: "#f9fafb", // Alternate row color for better readability
                    },
                  }}
                  key={customer.serviceRequestId}
                >
                  {/* <TableCell sx={{cursor:'pointer'}} onClick={() => handleDrawerOpen(customer)}>
                    {customer?.customerName}
                  </TableCell>
                  <TableCell>{customer?.mobileNumber}</TableCell>
                  <TableCell>{customer?.service?.subCategoryName}</TableCell>
                  <TableCell>{customer?.service?.serviceType}</TableCell>
                  <TableCell>{customer?.service?.categoryName}</TableCell>
                  <TableCell>{customer?.bookingId}</TableCell>
                  <TableCell>{customer?.address}</TableCell>
                  <TableCell>{customer?.pincode}</TableCell>

                  <TableCell>
                    {moment(customer?.serviceDate).startOf("hour").fromNow()}
                  </TableCell> */}
                  {visibleColumns?.map((col) => (
                  <TableCell
                    key={col.key}
                    sx={{
                      cursor:
                        col.key === "customerName" ? "pointer" : "default",
                    }}
                    onClick={
                      col.key === "customerName"
                        ? () => handleDrawerOpen(customer)
                        : undefined
                    }
                  >
                    {col.key === "serviceDate"
                      ? moment(customer?.serviceDate)
                          .startOf("hour")
                          .fromNow()
                      : col.key.includes(".")
                      ? col.key
                          .split(".")
                          .reduce((o, k) => (o ? o[k] : ""), customer)
                      : customer[col.key]}
                  </TableCell>
                ))}
                  {customer?.startLocation&&<TableCell>
               {} <Button variant="contained" color="primary" onClick={() => setlocationData(customer)}>
                    <LocationOn/> Track
                  </Button>
                </TableCell>}
                <TableCell>
                  <Button variant="contained" color="primary" onClick={() => setshowContract(customer?.serviceRequestId)}>
                    Contract
                  </Button>
                 
                </TableCell>
              
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25,50,100,200,500,1000,2000,100000]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <Modal
        open={isModalVisible}
        onClose={() => setisModalVisible(false)}
        aria-labelledby="modal-title"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          maxHeight: "900px",
        }}
        aria-describedby="modal-description"
      >
        <div className="bg-white h-[90%] p-10 w-1/2 rounded-md overflow-scroll">
          <div
            onClick={() => setisModalVisible(false)}
            style={{
              display: "flex",
              justifyContent: "space-between",
              cursor: "pointer",
              alignItems: "center",
            }}
          >
            <Typography id="modal-title" variant="h4" component="h2">
              Active Partner
            </Typography>
            <CloseIcon />
          </div>
          <div className="my-5 ">
            <table>
              <tr>
                <td>Partner Name:</td>
                <td>
                  <strong>{activePartner?.name}</strong>
                </td>
              </tr>
              <tr>
                <td>Mobile Number</td>
                <td>
                  <strong> {activePartner?.mobileNumber}</strong>
                </td>
              </tr>
              <tr>
                <td>Partner ID</td>
                <td>
                  <strong>{activePartner?.uniqueId}</strong>
                </td>
              </tr>
              <tr>
                <td>Service</td>
                <td>
                  <strong>{selectedService?.service?.categoryName}</strong>
                </td>
              </tr>
              <tr>
                <td>City</td>
                <td>
                  <strong>{activePartner?.city}</strong>
                </td>
              </tr>
              <tr>
                <td>Pincode</td>
                <td>
                  <strong>{activePartner?.pincode}</strong>
                </td>
              </tr>
            </table>
            {/* Active partner */}
          </div>
          <div>
            <Typography id="modal-title" variant="h4" component="h2">
              Available Partners
            </Typography>
          </div>
          <div className="w-full">
            <TableContainer>
              <Table>

            
            <TableHead>
              <TableRow className="font-semibold">
                <TableCell><strong>Partner Id</strong></TableCell>
                <TableCell><strong>Partner Name</strong></TableCell>
                <TableCell><strong>mobileNumber</strong></TableCell>
                <TableCell><strong>Service</strong></TableCell>
                <TableCell><strong>City</strong></TableCell>
                <TableCell><strong>PinCode</strong></TableCell>
                <TableCell></TableCell>
              </TableRow>
              </TableHead>
              {availablePartners?.map((item) => (
                <TableRow className="">
                  <TableCell>{item?.partner?.uniqueId}</TableCell>
                  <TableCell>{item?.partner?.name}</TableCell>
                  <TableCell>{item?.partner?.mobileNumber}</TableCell>
                  <TableCell>{item?.name}</TableCell>
                  <TableCell>{item?.partner?.city}</TableCell>
                  <TableCell>{item?.partner?.pincode}</TableCell>
                  <TableCell><Button onClick={()=>handleAssignWork(item?.partnerId,item?.serviceId,item?.partner?.managerId)} variant="contained" color="primary" type='button'>Assign</Button></TableCell>
                </TableRow>
              ))}
              </Table>
              </TableContainer>
          </div>
        </div>
      </Modal>
    </Container>
  );
};

export default Bookings;
